import { AxiosResponse } from 'axios';
import KrpTechopsAdminResource from '@/api/resource/KrpTechopsAdminResource';
import { AuditEntry } from '@/api/audit/AuditEntry';

export default class AuditResource extends KrpTechopsAdminResource {
  items: AuditEntry[] = [];

  public async getAll(filterParams: string): Promise<AuditEntry[]> {
    const url: string = `/api/krp/admin/audit${filterParams}`;

    const response: AxiosResponse = await this.apiClient.get(url);

    this.items = response.data.data;

    return this.items;
  }
}
